import { Injectable, Type } from "@angular/core";
import { Subject, BehaviorSubject } from "rxjs";

export interface DialogConfig {
    title?: string;
    description?: string;
    icon?: string;
    closable?: boolean;
    width?: string;
    breakpoints?: { [key: string]: string };
    bgColor?: string;
    contentClass?: string;
    data?: any;
}

export class DialogRef {
    data: any;
    private afterClosedSubject = new Subject<any>();

    constructor(
        private closeCallback: (data?: any) => void,
        public config?: DialogConfig
    ) {
        this.data = config?.data;
    }

    close(data?: any) {
        this.closeCallback(data);
        this.afterClosedSubject.next(data);
        this.afterClosedSubject.complete();
    }

    afterClosed() {
        return this.afterClosedSubject.asObservable();
    }
}

export interface DialogInstance {
    id: string;
    component: Type<any>;
    config: DialogConfig;
    ref: DialogRef;
}

@Injectable({
    providedIn: 'root'
})
export class DialogService {
    private dialogs: DialogInstance[] = [];
    private dialogsSubject = new BehaviorSubject<DialogInstance[]>([]);
    dialogs$ = this.dialogsSubject.asObservable();

    open(component: Type<any>, config: DialogConfig = {}): DialogRef {
        const finalConfig = {
            closable: true,
            width: '500px',
            bgColor: 'bg-white',
            contentClass: '',
            ...config
        };

        const id = Math.random().toString(36).substring(2, 9);

        const ref = new DialogRef((data) => {
            this.closeById(id);
            config.data?.onClose?.(data);
        }, finalConfig);

        this.dialogs.push({
            id,
            component,
            config: finalConfig,
            ref
        });
        this.dialogsSubject.next([...this.dialogs]);

        return ref;
    }

    closeById(id: string) {
        this.dialogs = this.dialogs.filter(d => d.id !== id);
        this.dialogsSubject.next([...this.dialogs]);
    }

    close() {
        if (this.dialogs.length > 0) {
            const topDialog = this.dialogs[this.dialogs.length - 1];
            topDialog.ref.close();
        }
    }
}